export default "__VITE_ASSET__78467526__"